<template>
    <div>
        <p class="modal-heading">Change phone number</p>
        <p class="text-sm">Please <a class="underlined" target="_blank" href="https://support.gttathome.com/support/tickets/new">Contact Digostics</a> to request a phone number reset</p>

        <div class="d-flex align-items-center mt-45">
            <!--<button :disabled="loading" @click="changePhoneNumber()" class="btn btn-success btn-lg lg-shadow d-flex flex-grow-1 w-50 justify-content-center align-items-center" :class="{disabled : loading}">Ok <span v-if="loading" class="btn-loading"></span></button>-->
            <button @click="$emit('close')" class="btn btn-success btn-lg lg-shadow d-flex flex-grow-1 w-50 justify-content-center align-items-center">Ok</button>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import axios from 'axios'
export default {
    name: 'ChangeUserPhoneNumberModalComponent',

    data() {
        return {
            loading: false
        }
    },

    computed: {
        ...mapGetters({
            organisationId: 'UserStore/GetUserOrganisationId'
        })
    },

    methods: {
        ...mapActions({
            setNotification: 'NotificationStore/SetNotification',
            signout: 'UserStore/Signout'
        }),

        async changePhoneNumber() {
            this.loading = true
            try {
                await axios.put(`${process.env.VUE_APP_AXIOS_ORGANISATION_BASE_URL}/api/v1/practitioners/reset-enrollment/${this.organisationId}/me`)

                this.$emit('close')

                await this.signout()
            }
            catch {
                this.setNotification({
                    type: 'error',
                    title: 'Error',
                    message: 'Something went wrong. Please try again'
                })
            }
            finally {
                this.loading = false
            }
        }
    }
}
</script>